/*eslint-disable no-script-url*/
/*global gtag*/
import React, { Component } from 'react';
import * as Common from '../components/Common';
import * as moment from 'moment';
import 'moment/locale/ko';
import { isIOS } from "react-device-detect";

import BranchRow from '../components/BranchRow';
import RequestForm from '../components/RequestForm';
import CurrentPosLabel from '../components/CurrentPosLabel';
import Reflux from 'reflux';
import { Actions } from '../components/Actions';

import BranchRegionPop from '../components/BranchRegionPop';
import BranchLocationPop from '../components/BranchLocationPop';
import CalendarPop from '../components/CalendarPop';
import ExperienceTypePop from '../components/ExperienceTypePop';
import StudyTypePop from '../components/StudyTypePop';
import RecogTypePop from '../components/RecogTypePop';
import MemberTypePop from '../components/MemberTypePop';

let experienceTypeMap = {
  'FULL_TIME': '종일 09:00 ~ 24:00',
  'A_TYPE': '오전 09:00 ~ 13:00',
  'B_TYPE': '오후 13:00 ~ 17:00',
  'C_TYPE': '야간 17:00 ~ 21:00',
  'D_TYPE': '심야 21:00 ~ 24:00'
}

class Experience extends Component {
  constructor(props) {
    super(props);

    this.state = {
      type: '',
      searchType: 'distance',
      centerLat: 0,
      centerLon: 0,
      selSido: '',
      selSigungu: '',
      selDong: '',
      branchList: null,
      calendarList: null,
      branch_id: 0,
      onessaas_branch_id: 0,
      pop_branch_id: 0,
      isOpenRegionPop: false,
      isOpenLocationPop: false,
      isOpenCalendarPop: false,
      isOpenExperienceTypePop: false,
      isOpenStudyTypePop: false,
      isOpenBirthdayPicker: false,
      isOpenRecogTypePop: false,
      isOpenMemberTypePop: false,
      pop_testUsedate: '',
      pop_experienceType: '',
      pop_studyType: '',
      pop_recogType: '',
      pop_memberType: '',
      minDate: '',
      maxDate: '',
      memberSex: '',
      memberBirthday: '',
      dateList: null,
      valueGroups: {},
      optionGroups: {}
    }

    Reflux.createStore({
      init: function() {
        this.listenTo(Actions.doCheckValidation, this.doCheckValidation);
        this.listenTo(Actions.doExperience, this.doExperience);
        this.listenTo(Actions.doInquiry, this.doInquiry);
      },
      doCheckValidation: () => {
        var _params = this._requestForm._getParams();
        var isValidation = this._checkValidation(_params);
        if(!isValidation) return false;

        var _type = this.state.type;
        if(_type === 'request') {
          var extendMsg = '<ul class="check-list">'
          + `<li>${_params.branchName}</li>`
          + `<li>${moment(_params.testUsedate, 'YYYY-MM-DD').format('M월 DD일 (ddd)')}</li>`
          + `<li>${experienceTypeMap[_params.experienceType]}</li>`
          + `<li>${Common.parsePhoneNumber(_params.memberPhone)}</li>`
          + '</ul>';
          Actions.alertOpen({msg: '지금 신청시 예약확정 됩니다.<br/>위와 같이 신청 하시겠습니까?', extendMsg: extendMsg}, [{type: 'cancel', label: '아니오'}, {type: 'ok', label: '네', callback: Actions.doExperience}]);
        } else if(_type === 'inquiry') {
          Actions.doInquiry();
        }
      },
      doExperience: () => {
        Common.callApi('/studytoz/freeExperienceReserve2', 'post', this._requestForm._getParams())
        .then(result => {
          if(result.resultCode.toLowerCase() === 'success') {
            gtag('event', '예약완료', {'event_category': '무료체험', 'event_label': '예약완료'});
            Actions.alertOpen({msg: '무료체험 신청이 완료 되었습니다.<br/>토즈를 이용해 주셔서 감사합니다.'}, [{type: 'ok', label: '확인', callback: Actions.doMovePage, param: '/'}]);
          } else if(result.resultApiCode === 'E9900') {
            Actions.alertOpen({msg: result.resultMessage}, [{type: 'ok', label: '확인'}]);
          }
        });
      },
      doInquiry: () => {
        var _params = this._requestForm._getParams();
        _params.branch_id = this.state.onessaas_branch_id;
        _params.phone = Common.parsePhoneNumber(_params.memberPhone);
        _params.isMarketingAgree = _params.isMarketingAgree ? 1 : 0;

        Common.callApi('/studytoz/freeExperienceInquiry', 'post', _params)
        .then(result => {
          if(result.resultCode.toLowerCase() === 'success') {
            gtag('event', '신청완료', {'event_category': '전화상담', 'event_label': '신청완료'});
            Actions.alertOpen({msg: '전화 상담 신청이 완료 되었습니다.<br/>토즈를 이용해주셔서 감사합니다.'}, [{type: 'ok', label: '확인', callback: Actions.doMovePage, param: '/'}]);
          }
        });
      }
    });
  }

  componentDidMount() {
    var pathnames = this.props.location.pathname.split('/');
    this.setState({
      type: pathnames[pathnames.length - 1],
      optionGroups: {
        year: Common.generateNumberArray(1970, parseInt(moment().format('YYYY'), 10) - 16),
        month: Common.generateNumberArray(1, 12),
        day: Common.generateNumberArray(1, 31)
      }
    });

    this._doSelectSearchTypeEvent(this.state.searchType);
  }
  
  _initState = (searchType) => {
    this.setState({
      searchType: searchType,
      branchList: null,
      calendarList: null,
      branch_id: 0,
      onessaas_branch_id: 0,
      pop_branch_id: 0,
      pop_testUsedate: '',
      pop_experienceType: '',
      pop_studyType: '',
      pop_recogType: '',
      pop_memberType: '',
      minDate: '',
      maxDate: '',
      memberSex: '',
      memberBirthday: '',
      dateList: null
    });
  }

  _doSelectSearchTypeEvent = (searchType) => {
    var lat = 0;
    var lon = 0;

    this._initState(searchType);

    var params = {
      onesBranchType: 'TSC',
      orderBy: searchType,
      addressSidoname: this.state.selSido,
      addressSigunguname: this.state.selSigungu,
      addressDongname: this.state.selDong,
      isExperience: 1
    };

    if(searchType === 'distance') {
      Actions.loadingState(true);
      if(navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
          lat = position.coords.latitude; // 위도(y)
          lon = position.coords.longitude; // 경도(x)

          if(isIOS) {
            Common.callApi('/coord2regioncode', 'get', {x: lon, y: lat})
            .then(result => {
              var _resultData = result.resultData;
              
              this.setState({
                centerLat: lat,
                centerLon: lon,
                currSido: _resultData.region_1depth_name,
                currSigungu: _resultData.region_2depth_name,
                currDong: _resultData.region_3depth_name
              });
  
              params.latitude = lat;
              params.longitude = lon;
        
              this._getBranches(params);
            });
          } else {
            var _body = {
              method: 'get',
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'KakaoAK 2fd61beb45e50a50ecfc63bbef4de789'
              }
            }
  
            fetch('//dapi.kakao.com/v2/local/geo/coord2regioncode.json?x=' + lon + '&y=' + lat, _body)
            .then(response => response.json())
            .then(json => {
              var _documents = json.documents;
              if(_documents.length > 0) {
                var _x = _documents[0].x;
                var _y = _documents[0].y;
  
                this.setState({
                  centerLat: _y,
                  centerLon: _x,
                  currSido: _documents[0].region_1depth_name,
                  currSigungu: _documents[0].region_2depth_name,
                  currDong: _documents[0].region_3depth_name
                });
  
                params.latitude = _y;
                params.longitude = _x;
          
                this._getBranches(params);
              }
            })
            .catch(err => {
              Actions.loadingState(false);
              Actions.alertOpen({msg: err}, [{type: 'ok', label: '확인'}]);
            });
          }
        }, (error) => {
          Actions.loadingState(false);
          Actions.alertOpen({msg: '위치정보를 가져올 수 없습니다.<br/>지역 검색으로 변경합니다.'}, [{type: 'ok', label: '확인', callback: this._doSelectSearchTypeEvent, param: 'location'}]);
        });
      } else {
        Actions.loadingState(false);
        Actions.alertOpen({msg: '위치정보를 가져올 수 없습니다.<br/>지역 검색으로 변경합니다.'}, [{type: 'ok', label: '확인', callback: this._doSelectSearchTypeEvent, param: 'location'}]);
      }
    } else if(searchType === 'location') {
      this._getBranches(params);
    }
  }

  _checkValidation = (params) => {
    var msg = "";
    var isValidation = true;
    if(this.state.type === 'request') {
      var _memberbirthday = params.memberBirthday;
      var _year, _month, _day, _limitYear = 0;
      if(_memberbirthday.length === 8) {
        _year = parseInt(_memberbirthday.substring(0, 4), 10);
        _month = parseInt(_memberbirthday.substring(4, 6), 10);
        _day = parseInt(_memberbirthday.substring(6, 8), 10);
        _limitYear = parseInt(moment().format('YYYY'), 10) - 16;
      }

      if(!params.memberSex) {
        msg = "이용자 성별을 선택해주세요.";
      } else if(!params.testUsedate) {
        msg = "체험 일자를 선택해주세요.";
      } else if(!params.experienceType) {
        msg = "체험 시간을 선택해주세요.";
      } else if(!params.memberName) {
        msg = "이름을 입력해주세요.";
      } else if(!params.memberBirthday) {
        msg = "생년월일을 입력해주세요.";
      } else if(params.memberBirthday.length < 8) {
        msg = "생년월일을 정확히 입력해주세요.";
      } else if(_year > _limitYear) {
				msg = _limitYear + "년생까지 무료체험 신청이 가능합니다.";
      } else if(_year < 1900 || _month > 12 || _day > 31) {
        msg = "생년월일을 정확히 입력해주세요.";
      } else if(!params.isVerifyPhone) {
        msg = "휴대번호 인증을 해주세요.";
      } else if(!params.studyType) {
        msg = "공부 목표를 선택해주세요.";
      } else if(!params.recogType) {
        msg = "인지 경로를 선택해주세요.";
      } else if(!params.isParentReservation) {
        msg = "학부모 여부를 선택해주세요.";
      } else if(!params.isPolicy) {
        msg = "이용약관에 동의해주세요.";
      } else if(!params.isPrivacy) {
        msg = "개인정보 처리방침에 동의해주세요.";
      }
    } else if(this.state.type === 'inquiry') {
      if(!params.memberName) {
        msg = "이름을 입력해주세요.";
      } else if(!params.memberType) {
        msg = "고객 유형을 선택해주세요.";
      } else if(!params.isVerifyPhone) {
        msg = "휴대번호 인증을 해주세요.";
      } else if(!params.isPolicy) {
        msg = "이용약관에 동의해주세요.";
      } else if(!params.isPrivacy) {
        msg = "개인정보 처리방침에 동의해주세요.";
      }
    }

    if(msg) {
      isValidation = false;
      Actions.alertOpen({msg: msg}, [{type: 'ok', label: '확인'}]);
    }
    
    return isValidation;
  }

  _doGetBranchEvent = (e) => {
    if(this.state.branch_id !== parseInt(e.target.value, 10)) {
      if(this._requestForm) this._requestForm._initParam(e.target.value);

      this.setState({
        branch_id: e.target.value,
        onessaas_branch_id: e.target.dataset.onessaas_branch_id,
        memberBirthday: '',
        pop_testUsedate: '',
        pop_experienceType: '',
        pop_studyType: '',
        pop_recogType: '',
        pop_memberType: ''
      });
    }
  }

  _doOpenRequestFormPop = (e) => {
    var type = e.target.dataset.type;
    var branch_id = e.target.dataset.branch_id;

    if(type === 'region') {
      this.setState({ isOpenRegionPop: true });
    } else if(type === 'location') {
      this.setState({ isOpenLocationPop: true });
    } else if(type === 'calendar') {
      var memberSex = this._requestForm._getParams().memberSex;
      if(memberSex === '') {
        Actions.alertOpen({msg: '성별을 먼저 선택해주세요.'}, [{type: 'ok', label: '확인'}]);
        return;
      }
      this.setState({ memberSex: memberSex });

      this._getCalendars(branch_id, memberSex);
    } else if(type === 'experienceType') {
      var testUsedate = this._requestForm._getParams().testUsedate;
      if(testUsedate === '') {
        Actions.alertOpen({msg: '체험일자를 먼저 선택해주세요.'}, [{type: 'ok', label: '확인'}]);
        return;
      }
      this.setState({ isOpenExperienceTypePop: true });
    } else if(type === 'memberBirthday') {
      this.setState({ isOpenBirthdayPicker: true });
    } else if(type === 'studyType') {
      this.setState({ isOpenStudyTypePop: true });
    } else if(type === 'recogType') {
      this.setState({ isOpenRecogTypePop: true });
    } else if(type === 'memberType') {
      this.setState({ isOpenMemberTypePop: true });
    }
    this.setState({ pop_branch_id: branch_id });

    Common.disableScroll();
  }

  _doCloseRequestFormPop = (e) => {
    var type = e.target.dataset.type;

    if(type === 'region') {
      var _sido = e.target.dataset.sido;
      var _sigungu = e.target.dataset.sigungu;
      var _dong = e.target.dataset.dong; 

      this._initState(this.state.searchType);

      this.setState({
        isOpenRegionPop: false,
        selSido: _sido,
        selSigungu: _sigungu,
        selDong: _dong
      });

      var params = {
        onesBranchType: 'TSC',
        orderBy: this.state.searchType,
        addressSidoname: _sido,
        addressSigunguname: _sigungu,
        addressDongname: _dong,
        latitude: this.state.centerLat,
        longitude: this.state.centerLon,
        isExperience: 1
      };

      this._getBranches(params);
    } else if(type === 'location') {
      this.setState({ isOpenLocationPop: false });
    } else if(type === 'calendar') {
      this.setState({ isOpenCalendarPop: false });
      // 체험일자
      var testUsedate = moment(new Date(e.target.dataset.testusedate)).format('YYYY-MM-DD');
      if(testUsedate === this.state.pop_testUsedate) return;

      var today = moment().format('YYYY-MM-DD');
      
      this.setState({
        pop_testUsedate: testUsedate && testUsedate !== today ? testUsedate : '',
        pop_experienceType: ''
      });
    } else if(type === 'experienceType') {
      // 체험시간
      this.setState({ 
        isOpenExperienceTypePop: false,
        pop_experienceType: e.target.dataset.experiencetype
      });
    } else if(type === 'memberBirthday') {
      // 생년월일
      var birthday = e.target.dataset.memberbirthday;
      this.setState({
        isOpenBirthdayPicker: false,
        memberBirthday: birthday ? e.target.dataset.memberbirthday : ''
      });
    } else if(type === 'studyType') {
      // 공부목표
      this.setState({ 
        isOpenStudyTypePop: false,
        pop_studyType: e.target.dataset.studytype
      });
    } else if(type === 'recogType') {
      // 인지경로
      this.setState({ 
        isOpenRecogTypePop: false,
        pop_recogType: e.target.dataset.recogtype
      });
    } else if(type === 'memberType') {
      this.setState({
        isOpenMemberTypePop: false,
        pop_memberType: e.target.dataset.membertype
      });
    }

    Common.enableScroll();
  }

  _getBranches = async (params) => {
    const result = await Common.callApi('/hp/branches', 'post', params);

    if(result.resultCode === 'success') {
      let _resultList = result.resultDataList;
      if(this.state.type === "inquiry") {
        // 전화상담신청에 수원광교1센터 제외 557
        let _idx = _resultList.findIndex(function (item) {return item.id === 557 });
        if(_idx > -1) _resultList.splice(_idx, 1);
      }
      this.setState({ branchList: _resultList });
    }
  }

  _branchRow0 = (e) => {
    if(e && e._input) e._input.click();
  }

  _getCalendars = async (branch_id, memberSex) => {
    var startdate = moment().add(1, 'day').format('YYYY-MM-DD');
    var enddate = moment().add(14, 'day').format('YYYY-MM-DD');

    const result = await Common.callApi('/studytoz/calendar2/' + (memberSex === '남' ? 'male' : 'female') + '/' + branch_id + '/' + startdate + '/' + enddate, 'get', null);
    var dateList = [];
    if(result.resultCode === 'success') {
      var resultDataList = result.resultData;
      this.setState({ calendarList: resultDataList });
      for(var date in resultDataList) {
        var entity = resultDataList[date];
        var isAllow = false;
        for(var key in entity) {
          if(entity[key] === true) {
            isAllow = true;
            break;
          }
        }
        
        if(isAllow) dateList.push(date);
      }

      if(!dateList || dateList.length === 0) {
        Actions.alertOpen({msg: '체험가능한 날짜가 없습니다.'}, [{type: 'ok', label: '확인'}]);
        return;
      }

      this.setState({
        dateList: dateList,
        isOpenCalendarPop: true
      });
    }
  }

  _renderTitle() {
    if(this.state.type === 'request') {
      return (
        <div>
          <div className="app-title">
            <p className="stxt">목표를 향한 첫 발걸음</p>
            <p className="btxt">
              <strong className="mgt">토즈</strong>가<br/><strong>무료체험</strong>으로 지원합니다.
            </p>
          </div>
        </div>
      )
    } else if(this.state.type === 'inquiry') {
      return (
        <div>
          <div className="app-title02">
						<p className="btxt">
							<strong className="mgt">토즈</strong>는<br/><strong>가까이</strong>있습니다.
						</p>
						<p className="stxt">
							전화 상담 신청을 남겨주시면 전문매니저가<br/>
							고객님의 <strong>일일 학습 가능 시간을 고려한<br/>
							좌석과 등록</strong>에 대해 <strong className="mgt">상세한 안내</strong>를 드립니다.
						</p>
					</div>
        </div>
      )
    }
  }

  render() {
    return (
      <div>
        <div id="skipNavi">
          <h1 className="blind">TOZ StudyCenter 스킵네비게이션</h1>
          <ul>
            <li><a href="#contents" className="skipLink">본문바로가기</a></li>
            <li><a href="#topmenu" className="skipLink">주메뉴바로가기</a></li>
          </ul>
        </div>
        <div id="doc" className="isPage">	
          <div id="pg-code" className="doc-pg">

            <div id="container-wrap" className="div-cont" >

              <div id="contents">
                <div className="app-header">
                  <p className="app-logo" onClick={() => {window.location.href = '/'}}><span className="blind">TOZ StudyCenter</span></p>
                  <a href="/" className="app-close"><span className="blind">닫기</span></a>
                </div>

                <div className="app-cont">
                  {this._renderTitle()}

                  <div className="sc-tit">{this.state.searchType === 'distance' ? '가까운 토즈를 찾아 주세요!' : '지역에 위치한 토즈를 찾아 주세요!'}</div>

                  <div className="appinfo-bbtn">
                    <a href={null} className={this.state.searchType === 'distance' ? 'current active' : 'current'} onClick={this._doSelectSearchTypeEvent.bind(this, 'distance')}>현 위치 기준</a>
                    <a href={null} className={this.state.searchType === 'location' ? 'area active' : 'area'} onClick={this._doSelectSearchTypeEvent.bind(this, 'location')}>지역 검색</a>
                  </div>

                  <CurrentPosLabel searchType={this.state.searchType} marginTop={this.state.searchType === 'distance' ? {marginTop: 0} : null} selSido={this.state.selSido} selSigungu={this.state.selSigungu} selDong={this.state.selDong} currSido={this.state.currSido} currSigungu={this.state.currSigungu} currDong={this.state.currDong} onClick={this._doOpenRequestFormPop} />

                  <div className="close-center">
                    <p className="title">{this.state.searchType === 'distance' ? '가장 가까운 센터' : '지역에 위치한 센터'}</p>
                    <ul className="list">
                      {this.state.branchList ? this.state.branchList.map((entity, index) => <BranchRow searchType={this.state.searchType} branch_id={this.state.branch_id} entity={entity} key={index} ref={this[`_branchRow${index}`]} onClick={this._doGetBranchEvent} />) : ''}
                    </ul>
                  </div>

                  {this.state.branch_id === 0 ? '' : <RequestForm type={this.state.type} branch_id={this.state.branch_id} testUsedate={this.state.pop_testUsedate} experienceType={this.state.pop_experienceType} studyType={this.state.pop_studyType} recogType={this.state.pop_recogType} memberType={this.state.pop_memberType} ref={ref => this._requestForm = ref} onClick={this._doOpenRequestFormPop} />}
                </div>
              </div>
            </div>
          </div>
        </div>
        {!this.state.isOpenRegionPop ? '' : <BranchRegionPop sido={this.state.selSido} sigungu={this.state.selSigungu} dong={this.state.selDong} onClick={this._doCloseRequestFormPop} />}
        {!this.state.isOpenLocationPop ? '' : <BranchLocationPop branch_id={this.state.pop_branch_id} onClick={this._doCloseRequestFormPop} />}
        {!this.state.isOpenCalendarPop ? '' : <CalendarPop testUsedate={this.state.pop_testUsedate} dateList={this.state.dateList} onClick={this._doCloseRequestFormPop} />}
        {!this.state.isOpenExperienceTypePop ? '' : <ExperienceTypePop testUsedate={this.state.pop_testUsedate} experienceType={this.state.pop_experienceType} calendarList={this.state.calendarList} onClick={this._doCloseRequestFormPop} />}
        {!this.state.isOpenStudyTypePop ? '' : <StudyTypePop studyType={this.state.pop_studyType} onClick={this._doCloseRequestFormPop} />}
        {!this.state.isOpenRecogTypePop ? '' : <RecogTypePop recogType={this.state.pop_recogType} onClick={this._doCloseRequestFormPop} />}
        {!this.state.isOpenMemberTypePop ? '' : <MemberTypePop memberType={this.state.pop_memberType} onClick={this._doCloseRequestFormPop} />}
      </div>
    )
  }
}

export default Experience;